import { useNavigate } from "react-router-dom"
import { useSetRecoilState } from "recoil"
import styled from "styled-components"
import { isMenuExpandedState } from "../../../recoil/common/Header"

const ExpandedMenuMobile1 = () => {
  const navigate = useNavigate()
  const setIsMenuExpanded = useSetRecoilState(isMenuExpandedState)

  return (
    <ExpandedMenuDiv>
      <SubMenuDiv>학문적성 검사 소개</SubMenuDiv>
      <SubMenuDiv
        onClick={() => {
          setIsMenuExpanded(false)
          navigate("/quiz")
        }}
      >
        검사하기
      </SubMenuDiv>
      <SubMenuDiv>검사 결과 보기</SubMenuDiv>
    </ExpandedMenuDiv>
  )
}

export default ExpandedMenuMobile1

const ExpandedMenuDiv = styled.div`
  display: flex;
  flex-direction: column;
`

const SubMenuDiv = styled.div`
  height: 40px;
  font-size: 16px;
  line-height: 40px;
`
